module.exports = __webpack_public_path__ + "img/1.ab0ef39f.jpg";